import { useFormField } from '@calendly/form';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { DateSpecificRules } from 'components/availability/form/date_specific_rules';
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction';
const containerIsTabletUpCss = "c1v22k0l";
const containerCss = "c2f3t2";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const DateSpecificHours = ({
  trackLocation
}) => {
  const {
    data: {
      timezone
    }
  } = useGetUserQuery();
  const [{
    value: activeDates
  }, _meta, {
    setValue: setActiveDates
  }] = useFormField({
    name: 'activeDates'
  });
  const [{
    value: days
  }] = useFormField({
    name: 'days'
  });
  const trackOpen = useTrackAvailabilityInteraction({
    location: trackLocation,
    action: 'view_date_specific_hours'
  });
  return <Container>
      <DateSpecificRules days={days} dates={activeDates} setDates={setActiveDates} timezone={timezone} trackOpen={trackOpen} redesignStyling />
    </Container>;
};

require("./date_specific_hours.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./date_specific_hours.js");